"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictationEvaluator = void 0;
const utils_1 = require("./utils");
class DictationEvaluator {
    async evaluate(submission, activity) {
        const targetText = (0, utils_1.normalizeWhitespace)(String(activity.config.targetText ?? '')).toLowerCase();
        const studentText = (0, utils_1.normalizeWhitespace)(String(submission.finalText ?? submission.structuredData?.answer ?? '')).toLowerCase();
        if (targetText === '') {
            return {
                score: 0,
                maxScore: 100,
                isCorrect: false,
                feedback: 'No target text available for dictation.',
                breakdown: [{ name: 'Accuracy', score: 0, maxScore: 100, feedback: 'Missing target text' }],
                skills: [{ key: 'dictation:unknown', label: 'Dictation' }],
                label: 'Dictation Score',
            };
        }
        const maxLen = Math.max(targetText.length, studentText.length, 1);
        const distance = (0, utils_1.levenshteinDistance)(targetText, studentText);
        const accuracy = 1 - (distance / maxLen);
        const score = Math.round(accuracy * 100);
        const isCorrect = score >= 90;
        let feedback = '';
        if (score >= 90)
            feedback = 'Great listening and writing! Nearly perfect.';
        else if (score >= 70)
            feedback = 'Good effort! A few words need attention.';
        else if (score >= 50)
            feedback = 'Keep practicing your listening and spelling.';
        else
            feedback = 'That was tricky. Listen carefully and try again.';
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                {
                    name: 'Word Accuracy',
                    score,
                    maxScore: 100,
                    feedback: `${distance} character difference(s)`,
                },
            ],
            skills: [{ key: `dictation:${targetText.slice(0, 20)}`, label: 'Dictation' }],
            label: 'Dictation Score',
        };
    }
}
exports.DictationEvaluator = DictationEvaluator;
